import type { FetchResult } from '@apollo/client';

export function wasMutationSuccessful(res: FetchResult): boolean {
  return res.errors == null || res.errors.length === 0;
}
